import { render, staticRenderFns } from "./QuizTeacherQuizList.vue?vue&type=template&id=63daee24&"
import script from "./QuizTeacherQuizList.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherQuizList.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherQuizList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports